import { useEffect, useState } from 'react'
import { Navigate } from 'react-router'

import { api } from '../api/client'
import type { FoodEntry } from '../api/types'
import { useAuth } from '../auth/AuthContext'
import EntryTable from '../components/EntryTable'

const Home: React.FC = () => {
  const { me, loading } = useAuth()
  const [entries, setEntries] = useState<FoodEntry[]>([])
  const [error, setError] = useState<string | null>(null)
  const [fetching, setFetching] = useState(true)

  useEffect(() => {
    if (!me) return
    setFetching(true)
    api
      .listEntries({ userId: me.id, limit: 50 })
      .then((r) => setEntries(r.items))
      .catch((e: Error) => setError(e.message))
      .finally(() => setFetching(false))
  }, [me])

  if (loading) return <p className="text-gray-500">Loading…</p>
  if (!me) return <Navigate to="/login" replace />

  return (
    <section>
      <header className="mb-4 flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold">My entries</h1>
          <p className="text-sm text-gray-500">
            Latest 50 entries for {me.email}.
          </p>
        </div>
      </header>
      {error && (
        <p className="mb-3 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
      )}
      {fetching ? (
        <p className="text-gray-500">Loading entries…</p>
      ) : (
        <EntryTable entries={entries} emptyMessage="No entries yet. Use the API to add some." />
      )}
    </section>
  )
}

export default Home
